import React from 'react';
import { Button } from './Button';

import './Dialog.css';

export const Dialog = (props) => {

  return (
    <div className={["dialog", props.className].join(' ')}>
      <h2>{props.title}</h2>
      <div>
        <div className="box" style={{position: 'relative'}}>
          {props.children}
        </div>
      </div>
    </div>
  );
}

export const TwoButtonDialog = (props) => {
  return (
    <Dialog title={props.title}>
      <div className="message">{props.children}</div>
      <div className="buttonArea"><Button type="button" onClick={props.onButton1}>{props.button1Label}</Button> <Button type="button" onClick={props.onButton2}>{props.button2Label}</Button></div>
    </Dialog>
  )
}